// extracted by css-extract-rspack-plugin
export default {"labelContainer":"labelContainer-WepOcc","icon":"icon-uBd_TA","label2Container":"label2Container-o6PqJ1","disabled":"disabled-_G9qu6","checked":"checked-WtA92e"};